export default {
    TAB_HEIGHT: 40
};
